/**
 * FormSection - Groups related fields with consistent spacing
 */
const FormSection = ({ 
  title, 
  description, 
  children,
  showDivider = false,
}) => {
  return (
    <div style={{ marginBottom: '48px' }}>
      {title && (
        <div style={{ marginBottom: '24px' }}>
          <h3 style={{
            fontSize: '18px',
            fontWeight: 600,
            color: '#1a1a1a',
            marginBottom: '4px',
          }}>
            {title}
          </h3>
          {description && (
            <p style={{
              fontSize: '14px',
              color: '#6c757d',
              marginBottom: 0,
              lineHeight: 1.5,
            }}>
              {description}
            </p>
          )}
        </div>
      )}
      
      {children}
      
      {showDivider && (
        <hr style={{
          marginTop: '48px',
          border: 'none',
          borderTop: '1px solid #e9ecef',
        }} />
      )}
    </div>
  );
};

export default FormSection;
